import axiosInstance from "./axiosInstance";

const roleService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/roles/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    getSingle: async (id) => {
        try {
            const response = await axiosInstance.get(`/roles/single/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    getAll: async () => {
        try {
            const response = await axiosInstance.get('/roles/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/roles/update/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    activate: async (id) => {
        try {
            const response = await axiosInstance.put(`/roles/activate/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    deactivate: async (id) => {
        try {
            const response = await axiosInstance.put(`/roles/deactivate/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    delete: async (id) => {
        try {
            const response = await axiosInstance.delete(`/roles/delete/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default roleService;
